"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInactiveListener = exports.useEagerConnect = exports.useWeb3Provider = exports.Web3Provider = void 0;
var core_1 = require("@web3-react/core");
var injected_connector_1 = require("@web3-react/injected-connector");
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var LaunchpadProvider_1 = require("../../../LaunchpadProvider");
var connectors_1 = require("../../../shared/hooks/useWeb3/connectors");
var switchMetamaskChain_1 = require("../../../shared/hooks/useWeb3/switchMetamaskChain");
var useStaticWeb3_1 = require("../../../shared/hooks/useWeb3/useStaticWeb3");
var utils_1 = require("../../../shared/utils");
function useWeb3(_a) {
    var _this = this;
    var chain = _a.chain, useUserConnectionByDefault = _a.useUserConnectionByDefault, printDebug = _a.printDebug;
    var _b = (0, LaunchpadProvider_1.useLaunchpadProvider)(), chains = _b.chains, defaultChain = _b.defaultChain;
    var staticWeb3 = (0, useStaticWeb3_1.useStaticWeb3)();
    var _c = (0, react_1.useState)(function () { return chains.find(function (c) { return c.symbol === chain; }) || defaultChain; }), targetChain = _c[0], setTargetChain = _c[1];
    var connectorsByName = (0, react_1.useMemo)(function () { return ({
        Injected: (0, connectors_1.createInjectedConnector)(chains.map(function (c) { return c.id; })),
        WalletConnect: (0, connectors_1.createWalletconnectConnector)(targetChain.id, targetChain.urls[0]),
    }); }, [chains, targetChain]);
    var _d = (0, core_1.useWeb3React)(), connector = _d.connector, library = _d.library, chainId = _d.chainId, account = _d.account, activate = _d.activate, deactivate = _d.deactivate, error = _d.error;
    var connectedToDefault = chainId === (defaultChain === null || defaultChain === void 0 ? void 0 : defaultChain.id);
    var _e = (0, react_1.useState)(), activatingConnector = _e[0], setActivatingConnector = _e[1];
    (0, react_1.useEffect)(function () {
        if (activatingConnector && activatingConnector === connector) {
            setActivatingConnector(undefined);
        }
    }, [activatingConnector, connector]);
    // handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
    var triedEager = useEagerConnect(connectorsByName.Injected);
    // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
    useInactiveListener(connectorsByName.Injected, !triedEager || !!activatingConnector);
    function connectTo(name) {
        setActivatingConnector(connectorsByName[name]);
        return activate(connectorsByName[name]);
    }
    var usingChainId = chainId && !connectedToDefault ? chainId : defaultChain.id;
    var targetChainWeb3 = chainId === targetChain.id ? library : null;
    var connectedChain = chains.find(function (c) { return c.id === usingChainId; });
    var isValidChain = !(error instanceof core_1.UnsupportedChainIdError) &&
        targetChain.id === usingChainId;
    useLogWeb3State({
        defaultChain: defaultChain,
        targetChain: targetChain,
        connectedChain: connectedChain,
        connectedToDefault: connectedToDefault,
        usingChainId: usingChainId,
        useUserConnectionByDefault: useUserConnectionByDefault,
        isValidChain: isValidChain,
        printDebug: printDebug,
    });
    return {
        account: account,
        // User, injected web3, use for buying/approving
        web3: connectedToDefault && library ? library : staticWeb3,
        // Network web3, do not use for sending TXs
        staticWeb3: staticWeb3,
        // available only if connected to the correct requested network
        targetChainWeb3: targetChainWeb3,
        // currently connected web3
        connectedWeb3: library,
        targetChain: targetChain,
        connectedChain: connectedChain,
        defaultChain: defaultChain,
        isValidChain: isValidChain,
        error: error,
        connectWalletConnect: function () { return connectTo('WalletConnect'); },
        connectMetamask: function () { return connectTo('Injected'); },
        connectTrustWallet: function () { return connectTo('Injected'); },
        logout: function () {
            try {
                connector.close();
            }
            catch (e) {
                // ignore
            }
            deactivate();
        },
        switchToChain: function (chain) { return __awaiter(_this, void 0, void 0, function () {
            var newChain;
            return __generator(this, function (_a) {
                newChain = chains.find(function (c) { return c.symbol === chain; });
                setTargetChain(chains.find(function (c) { return c.symbol === chain; }));
                if (connector instanceof injected_connector_1.InjectedConnector) {
                    connector.getProvider().then(function (provider) {
                        (0, switchMetamaskChain_1.switchMetamaskChain)({
                            toChain: chain,
                            metaProvider: provider,
                            providerUrl: newChain.urls[0],
                        });
                    });
                }
                return [2 /*return*/];
            });
        }); },
    };
}
var _a = (0, constate_1.default)(useWeb3), Web3Provider = _a[0], useWeb3Provider = _a[1];
exports.Web3Provider = Web3Provider;
exports.useWeb3Provider = useWeb3Provider;
function useLogWeb3State(_a) {
    var defaultChain = _a.defaultChain, targetChain = _a.targetChain, connectedChain = _a.connectedChain, connectedToDefault = _a.connectedToDefault, usingChainId = _a.usingChainId, useUserConnectionByDefault = _a.useUserConnectionByDefault, isValidChain = _a.isValidChain, printDebug = _a.printDebug;
    var print = function () {
        return printDebug &&
            (0, utils_1.debug)('Web3 state', {
                defaultChain: defaultChain,
                targetChain: targetChain,
                connectedChain: connectedChain,
                connectedToDefault: connectedToDefault,
                usingChainId: usingChainId,
                useUserConnectionByDefault: useUserConnectionByDefault,
                isValidChain: isValidChain,
            });
    };
    if (typeof window === 'undefined') {
        print();
    }
    (0, react_1.useEffect)(function () {
        print();
    }, [
        defaultChain === null || defaultChain === void 0 ? void 0 : defaultChain.id,
        targetChain === null || targetChain === void 0 ? void 0 : targetChain.id,
        connectedChain === null || connectedChain === void 0 ? void 0 : connectedChain.id,
        connectedToDefault,
        usingChainId,
        useUserConnectionByDefault,
        isValidChain,
    ]);
}
function useEagerConnect(injected) {
    var _a = (0, core_1.useWeb3React)(), activate = _a.activate, active = _a.active;
    var _b = (0, react_1.useState)(false), tried = _b[0], setTried = _b[1];
    (0, react_1.useEffect)(function () {
        injected.isAuthorized().then(function (isAuthorized) {
            if (isAuthorized) {
                activate(injected, undefined, true).catch(function () {
                    setTried(true);
                });
            }
            else {
                setTried(true);
            }
        });
    }, []); // intentionally only running on mount (make sure it's only mounted once :))
    // if the connection worked, wait until we get confirmation of that to flip the flag
    (0, react_1.useEffect)(function () {
        if (!tried && active) {
            setTried(true);
        }
    }, [tried, active]);
    return tried;
}
exports.useEagerConnect = useEagerConnect;
function useInactiveListener(injected, suppress) {
    if (suppress === void 0) { suppress = false; }
    var _a = (0, core_1.useWeb3React)(), active = _a.active, error = _a.error, activate = _a.activate;
    (0, react_1.useEffect)(function () {
        var ethereum = window.ethereum;
        if (ethereum && ethereum.on && !active && !error && !suppress) {
            var handleConnect_1 = function () {
                console.log("Handling 'connect' event");
                activate(injected);
            };
            var handleChainChanged_1 = function (chainId) {
                console.log("Handling 'chainChanged' event with payload", chainId);
                activate(injected);
            };
            var handleAccountsChanged_1 = function (accounts) {
                console.log("Handling 'accountsChanged' event with payload", accounts);
                if (accounts.length > 0) {
                    activate(injected);
                }
            };
            var handleNetworkChanged_1 = function (networkId) {
                console.log("Handling 'networkChanged' event with payload", networkId);
                activate(injected);
            };
            ethereum.on('connect', handleConnect_1);
            ethereum.on('chainChanged', handleChainChanged_1);
            ethereum.on('accountsChanged', handleAccountsChanged_1);
            ethereum.on('networkChanged', handleNetworkChanged_1);
            return function () {
                if (ethereum.removeListener) {
                    ethereum.removeListener('connect', handleConnect_1);
                    ethereum.removeListener('chainChanged', handleChainChanged_1);
                    ethereum.removeListener('accountsChanged', handleAccountsChanged_1);
                    ethereum.removeListener('networkChanged', handleNetworkChanged_1);
                }
            };
        }
    }, [active, error, suppress, activate]);
}
exports.useInactiveListener = useInactiveListener;
